// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3dOTz","row":"Node_row__3iSek","label":"Node_label__iq7ga","footer":"Node_footer__1UdGl"};